import React from 'react';
import styled from 'styled-components';

const TeacherDiscountLogo = (props) => {
  return (
    <>
      <CustomSVG
        width="64"
        height="60"
        viewBox="0 0 64 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M63.4196 29.8596C63.4196 33.0529 60.621 35.7789 59.6614 38.6607C58.7019 41.5425 59.2483 45.4432 57.3892 47.9291C55.5102 50.4409 51.6121 51.064 49.0334 52.8943C46.4813 54.7051 44.6756 58.1321 41.6104 59.1057C38.5453 60.0792 35.1337 58.3268 31.8553 58.3268C28.5769 58.3268 25.0587 60.0403 22.1002 59.0992C19.035 58.1321 17.2292 54.6986 14.6772 52.8878C12.1251 51.077 8.20041 50.4344 6.32134 47.9226C4.44228 45.4108 5.04865 41.6398 4.04914 38.6542C3.08962 35.7724 0.291016 33.0464 0.291016 29.8531C0.291016 26.6598 3.08962 23.9338 4.04914 21.0521C5.04198 18.0664 4.46227 14.2695 6.32134 11.7837C8.18042 9.29782 12.0985 8.64878 14.6772 6.81846C17.2559 4.98815 19.035 1.58065 22.1002 0.607083C25.0587 -0.327544 28.5769 1.38594 31.8553 1.38594C35.1337 1.38594 38.6519 -0.327538 41.6104 0.61358C44.569 1.5547 46.4813 5.01411 49.0334 6.82495C51.5855 8.63579 55.5102 9.27835 57.3892 11.7902C59.2683 14.302 58.6619 18.0729 59.6614 21.0585C60.6609 24.0442 63.4196 26.6663 63.4196 29.8596Z"
          fill={props.color}
          fill-opacity="0.4"
          className='color-animation'
        />
        <path
          d="M60.7712 29.8602C60.7712 32.8018 58.1931 35.313 57.3093 37.9676C56.4254 40.6222 56.9287 44.2156 55.2161 46.5055C53.4852 48.8193 49.8943 49.3933 47.5189 51.0794C45.168 52.7475 43.5045 55.9044 40.681 56.8012C37.8574 57.698 34.7147 56.0837 31.6947 56.0837C28.6747 56.0837 25.4337 57.6622 22.7084 56.7952C19.8848 55.9044 18.2214 52.7415 15.8705 51.0734C13.5196 49.4053 9.90417 48.8134 8.17321 46.4995C6.44224 44.1857 7.00082 40.7119 6.08009 37.9616C5.1962 35.307 2.61816 32.7958 2.61816 29.8542C2.61816 26.9126 5.1962 24.4014 6.08009 21.7468C6.99468 18.9965 6.46066 15.4988 8.17321 13.2089C9.88576 10.919 13.495 10.3211 15.8705 8.63505C18.2459 6.94899 19.8848 3.81006 22.7084 2.91322C25.4337 2.05226 28.6747 3.63069 31.6947 3.63069C34.7147 3.63069 37.9556 2.05226 40.681 2.91921C43.4063 3.78615 45.168 6.97291 47.5189 8.64102C49.8698 10.3091 53.4852 10.9011 55.2161 13.2149C56.9471 15.5287 56.3885 19.0025 57.3093 21.7528C58.23 24.5031 60.7712 26.9186 60.7712 29.8602Z"
          fill={props.color}
          className='color-animation'
        />
      </CustomSVG>
    </>
  );
};

const CustomSVG = styled.svg`
  .color-animation {
    animation: changeColor 2.2s linear;
    fill: #c20f03;
    @keyframes changeColor {
      0% {
        fill: #b746e6;
      }
      100% {
        fill: #c20f03;
      }
    }
  }
`;

export default TeacherDiscountLogo;
